import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetTreeNavigator } from './useGetTreeNavigator'
// import { TreeNavigatorContent } from './TreeNavigatorContent'
import { TreeNavigatorContentV2 } from './TreeNavigatorContentV2'

export const TreeNavigatorComponent = ({
  id,
  tileContainerRef,
}: {
  id: string
  tileContainerRef: React.RefObject<HTMLDivElement>
}) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetTreeNavigator(id, tileFilterSelections)

  return (
    // <TreeNavigatorContent
    <TreeNavigatorContentV2
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
      tileContainerRef={tileContainerRef}
    />
  )
}

export function TreeNavigatorComponentLoading() {
  return 'Loading...'
}
